import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './ecom_v2/Header';
import Footer from './ecom_v2/Footer';
import Home from './ecom_v2/Home';
import Pieces from './ecom_v2/Pieces';
import Atelier from './ecom_v2/Atelier';
import Private from './ecom_v2/Private';

export default function EcommerceTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F2E8D5]" data-testid="vm-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`vm-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'pieces' && <Pieces setPage={setPage} />}
          {page === 'atelier' && <Atelier setPage={setPage} />}
          {page === 'private' && <Private setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
